import { Tabs, TabsProps } from "@mui/material";
import { styled } from "@mui/system";

export const StyledTabs = styled((props: TabsProps) => <Tabs {...props} />)({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
});
